export default __webpack_public_path__ + "static/media/lawn_mower.2afcd99d.png";